import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PortfolioService } from '../shared/services/portfolio.service';
import { PortfolioAccountManagerAdminModel } from '../shared/models/portfolio-account-manager-admin-model';
import { PortfolioModel } from '../shared/models/portfolio-model';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PortfolioSalesAssistant } from '../shared/models/portfolio-sales-assistant.model';

@Component({
  selector: 'app-portfolio-add-sales-assistant',
  templateUrl: './portfolio-add-sales-assistant.component.html',
  styleUrls: ['./portfolio-add-sales-assistant.component.less'],
  standalone: false,
})
export class PortfolioAddSalesAssistantComponent implements OnInit {
  @Input()
  adminId: number;

  public selectedAssistantId: number;
  public accountManagers$: Observable<PortfolioAccountManagerAdminModel[]>;

  @Input()
  public portfolio: PortfolioModel;

  public admins$: Observable<PortfolioAccountManagerAdminModel[]>;

  constructor(
    private portfolioService: PortfolioService,
    private translationService: TranslateService
  ) {}

  public onUpdateSalesAssistantClick() {
    let portfolio = this.portfolio;
    this.portfolioService
      .saveAssistant(this.portfolio.portfolioId, this.selectedAssistantId)
      .subscribe(() => {
        this.selectedAssistantId = null;
        this.getAssistantData();
      });
  }

  public onRemoveAssistant(portfolioSalesAssistantId: number) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }

    this.portfolioService
      .removeAssistant(portfolioSalesAssistantId)
      .subscribe((d) => {
        this.getAssistantData();
      });
  }

  public getAssistantData() {
    this.salesAssitantReload$.next(true);
  }

  public getAccountManagers() {
    return this.portfolioService.accountManagerList();
  }

  public salesAssistants$: Observable<PortfolioSalesAssistant[]>;
  public salesAssitantReload$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(true);

  ngOnInit() {
    this.salesAssistants$ = this.salesAssitantReload$.pipe(
      switchMap(() =>
        this.portfolioService.getAssistants(this.portfolio.portfolioId).pipe(
          map((c) => {
            return c.data;
          })
        )
      )
    );

    this.admins$ = this.getAccountManagers().pipe(map((c) => c.items));

    this.accountManagers$ = combineLatest([
      this.salesAssistants$,
      this.admins$,
    ]).pipe(
      map(([assistants, admins]) => {
        let usedSalesAssistantAdminIdList = assistants.map((c) => c.adminId);
        let adminIdSet = new Set<number>(usedSalesAssistantAdminIdList);
        adminIdSet.add(this.portfolio.currentAccountManager.admin.adminId);
        let result = admins.filter((x) => !adminIdSet.has(x.adminId));

        return result;
      })
    );
  }
}
